<template>
  <div :class="`${props.border ? 'wrapper' : ''} ${props.padding ? 'p-4' : ''}`.trim()">
  <h5 class="mb-3 sub-title" v-if="props.title">{{ props.title }}</h5>
    <template v-if="hasSlot('search')">
      <MDBRow>
        <MDBCol cols="12" md="6">
          <template v-if="hasSlot('description')">
            <slot name="description"></slot>
          </template>
          <div
            v-if="props.description"
            class="description"
            v-html="props.description"
          ></div>
        </MDBCol>
        <MDBCol cols="12" md="6">
          <slot name="search"></slot>
        </MDBCol>
      </MDBRow>
    </template>
    <template v-else>
      <template v-if="hasSlot('description')">
        <slot name="description"></slot>
      </template>
      <div
        v-if="props.description"
        class="description"
        v-html="props.description"
      ></div>
    </template>
    <template v-for="slotName in slotOrder" :key="slotName">
      <div v-if="hasSlot(slotName)" :class="slotName + ' mb-0'">
        <slot :name="slotName"></slot>
      </div>
    </template>
  </div>
</template>

<script setup>
import { MDBCol, MDBRow } from "mdb-vue-ui-kit";

import {computed, defineProps, useSlots} from "vue";

const props = defineProps({
  title: String,
  description: String,
  border: {
    type: Boolean,
    default: true,
  },
  padding: {
    type: Boolean,
    default: true,
  },
  firstContent: {
    type: Boolean,
    default: false,
  }
});

const hasSlot = (name) => !!useSlots()[name];

const slotOrder = computed(() =>
    props.firstContent ? ['content', 'table'] : ['table', 'content']
);
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/dashboard_card.scss";
</style>
